export function is_allowed(permissions = {}, userType, module = '', action = ''){
    // console.log(permissions, userType)
    if (userType == 4){
    return permissions[module]?.includes(action) || false;
    }
    else{
        return true
    }
}